<!-- #72 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Inbound Orders/Receipt
      </div>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        v-if="checkPermission('app_infor:infor_v1_inbound_bulk_upload')"
        small
        @click="$router.push('/inbound-bulk-upload')"
        class="mr-3"
        >Bulk Upload</v-btn
      >
      <v-btn
        color="primary"
        v-if="checkPermission('app_infor:infor_v1_inbound_upload')"
        small
        @click="$router.push('/inbound-upload')"
        class="mr-8"
        >Add Inbound Orders/Receipt</v-btn
      >
    </div>
    <v-divider class="mt-1 mb-4 mr-8"></v-divider>
    <v-data-table
      :headers="headers"
      :items="inboundOrder"
      :options.sync="options"
      :server-items-length="total"
      :loading="inboundOrderLoader"
      class="elevation-1 custom-icon-size mr-8"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <template>
          <v-form>
            <div class="custom-row">
              <v-col cols="12" sm="3" md="3" class="pb-0">
                <v-autocomplete
                  v-model="warehouse_id"
                  label="Warehouse"
                  item-text="name"
                  item-value="id"
                  :items="warehouses"
                  outlined
                  @change="fetchClientList(), getType()"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                sm="3"
                v-if="
                  userCategory.user_category === 3 ||
                  userCategory.user_category === 6
                "
                class="pb-0"
              >
                <v-autocomplete
                  v-model="selectedClient"
                  :items="clients"
                  :loading="clientLoader"
                  hide-no-data
                  item-text="name"
                  item-value="id"
                  label="Select Client"
                  placeholder="Start typing to Search"
                  class="pb-2 pt-0 text-center"
                  outlined
                  @change="getStores(selectedClient, warehouse_id)"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3" md="3" class="pb-0">
                <v-autocomplete
                  v-model="infor_storer_id"
                  label="Storer Name"
                  item-text="channel_name"
                  item-value="id"
                  :items="stores"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0">
                <v-text-field
                  label="Receipt key"
                  outlined
                  v-model="receipt_key"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0">
                <v-text-field
                  label="External Receipt"
                  outlined
                  v-model="receipt_no"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="3" class="pb-0">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(from_date)"
                      label="From Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('this.from_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="from_date"
                    @input="dateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0">
                <v-menu
                  v-model="dateMenuTo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(to_date)"
                      label="To Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('this.to_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="to_date"
                    @input="dateMenuTo = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="3" class="pb-0">
                <v-autocomplete
                  v-model="status"
                  :items="statuses"
                  item-text="name"
                  item-value="id"
                  label="Status"
                  placeholder="Start typing to Search"
                  class="pb-2 pt-0 text-center"
                  @focus="fetchStatus"
                  outlined
                  multiple
                  :search-input.sync="searchText"
                  @input="onValueChange"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0" v-if="warehouse_id">
                <v-autocomplete
                  v-model="order_type"
                  :items="typesArr"
                  hide-no-data
                  item-text="value"
                  item-value="key"
                  label="Type"
                  placeholder="Start typing to Search"
                  class="pb-2 pt-0 text-center"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col
                :cols="
                  warehouse_id &&
                  (userCategory.user_category == 3 ||
                    userCategory.user_category == 6)
                    ? 9
                    : 12
                "
                class="pr-4"
                sm="
                12
                "
              >
                <v-btn color="white" @click="clearAll" style="float: right"
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success mr-3"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
                <v-btn
                  color="primary"
                  class="mr-3"
                  @click="sync()"
                  style="float: right"
                  v-if="
                    checkPermission('app_infor:b2b_inbound_sync') &&
                    warehouse_id
                  "
                  >Sync</v-btn
                >
                <v-btn
                  color="green"
                  style="float: right"
                  dark
                  class="mr-3"
                  v-if="checkPermission('app_ecom_vendors:excel_details')"
                  @click="listPage"
                >
                  Uploaded List
                </v-btn>
              </v-col>
            </div>
          </v-form>
          <v-divider class="mb-5"></v-divider>
        </template>
      </template>
      <template v-slot:[`item.stages_status`]="{ item }">
        <span
          @click="openStageMessage(item)"
          v-if="item.stages_status == 'Failed'"
          ><a>{{ item.stages_status }}</a></span
        >
        <span v-else>{{ item.stages_status }}</span>
      </template>

      <template v-slot:[`item.receipt_key`]="{ item }">
        <a
          ><span @click="findSummary(item.id, item, true)">{{
            item.receipt_key
          }}</span></a
        ><v-icon
          @click="gotodetails(item)"
          class="ml-2"
          v-if="
            checkIcon(item) &&
            checkPermission('app_sku_variant:b2b_inbound_variant_summary')
          "
          >mdi-eye</v-icon
        >
        <br />
        <span v-if="item.receipt_no">({{ item.receipt_no }})</span>
      </template>

      <template v-slot:[`item.created_at`]="{ item }">
        <span v-if="item.created_at"
          >{{ item.created_at | localMomentNew | moment("DD MMM, YYYY hh:mm A")
          }}<br /><span v-if="item.created_by"
            >({{ item.created_by }})</span
          ></span
        >
      </template>
      <template v-slot:[`item.updated_at`]="{ item }">
        <span v-if="item.updated_at"
          >{{ item.updated_at | localMomentNew | moment("DD MMM, YYYY hh:mm A")
          }}<br /><span v-if="item.updated_by__name"
            >({{ item.updated_by__name }})</span
          ></span
        >
      </template>

      <template v-slot:[`item.PUTAWAY_COMPLETED_QTY`]="{ item }">
        {{ getData(item, "PUTAWAY_COMPLETED_QTY") }}
      </template>
      <template v-slot:[`item.RECEIVED_QTY`]="{ item }">
        {{ getData(item, "RECEIVED_QTY") }}
      </template>
      <template v-slot:[`item.EXPECTED_QTY`]="{ item }">
        {{ getData(item, "EXPECTED_QTY") }}
      </template>
      <template v-slot:[`item.DAMAGE_QTY`]="{ item }">
        {{ getData(item, "DAMAGE_QTY") }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip
          bottom
          v-if="checkPermission('app_infor:infor_v1_inbound_itemlist')"
        >
          <template v-slot:activator="{ on }">
            <v-icon
              medium
              class="mr-2"
              v-on="on"
              @click="findSummary(item.id, item, true)"
            >
              mdi-archive-check-outline
            </v-icon>
          </template>
          <span>Order Summary</span>
        </v-tooltip>
        <v-tooltip
          bottom
          v-if="checkPermission('app_infor:b2b_infor_v1_inbound_download')"
        >
          <template v-slot:activator="{ on }">
            <v-icon medium class="mr-2" v-on="on" @click="downloadData(item)">
              mdi-download
            </v-icon>
          </template>
          <span>Download Order</span>
        </v-tooltip>
        <v-tooltip
          bottom
          v-if="
            checkPermission('app_infor:b2b_inbound_asn_grr_closure_generate') &&
            (item.status == 'Closed' || item.status == 'Verified Closed')
          "
        >
          <template v-slot:activator="{ on }">
            <v-icon medium class="mr-2" v-on="on" @click="downloadASN(item)">
              mdi-receipt
            </v-icon>
          </template>
          <span>Goods Received Download</span>
        </v-tooltip>
        <v-tooltip
          bottom
          v-if="checkPermission('app_infor:inbound_report_summary_sync')"
        >
          <template v-slot:activator="{ on }">
            <v-icon medium class="mr-2" v-on="on" @click="syncData(item)">
              mdi-sync
            </v-icon>
          </template>
          <span>Sync</span>
        </v-tooltip>

        <v-tooltip bottom v-if="checkPermission('app_infor:inbound_cancel')">
          <template v-slot:activator="{ on }">
            <v-icon
              medium
              class="mr-2"
              v-on="on"
              @click="confirmation(item)"
              v-if="item.status !== 'Cancelled' && item.status !== 'Closed'"
            >
              mdi-cancel
            </v-icon>
          </template>
          <span>Cancellation</span>
        </v-tooltip>
        <v-tooltip
          bottom
          v-if="
            checkPermission('app_infor:b2b_inbound_transaction') &&
            chechTransaction(item)
          "
        >
          <template v-slot:activator="{ on }">
            <v-icon
              medium
              class="mr-2"
              v-on="on"
              @click="transactionData(item)"
            >
              mdi-transfer
            </v-icon>
          </template>
          <span>Transaction</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="openDialog(item)"
              v-if="
                checkStatus(item) &&
                checkPermission('app_infor:inbound_receive') &&
                (userCategory.user_category == 3 ||
                  userCategory.user_category == 6)
              "
            >
              mdi-call-received
            </v-icon>
          </template>
          <span>Receive Order</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="edit(item)"
              v-if="
                checkPermission('app_infor:inbound_get_order_details') &&
                item.source !== 'API' &&
                item.source !== 'BULK-EXCEL' &&
                item.status == 'New'
              "
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Edit Order</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.oms_order_date_time`]="{ item }">
        <span v-if="item.oms_order_date_time">{{
          item.oms_order_date_time
            | localMoment
            | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>

      <template v-slot:[`item.client_name`]="{ item }">
        {{ item.client_name }}
        <span v-if="item.storer_key">({{ item.storer_key }})</span>
      </template>
      <template v-slot:[`item.shipping_address_country`]="{ item }">
        <label>
          {{ item.shipping_address_country }}
        </label>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-divider class="mb-2"></v-divider>
        <v-card-text>Are you sure to cancel this order?</v-card-text>
        <v-card-actions>
          <v-btn color="green darken-1" class="primary" @click="dialog = false"
            >No</v-btn
          >
          <v-btn
            color="red darken-1"
            class="success"
            @click="
              cancelOrder();
              dialog = false;
            "
            >Yes</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="loader-wrapper" v-if="isloading">
      <div class="loader"></div>
    </div>
    <ConfirmDialog
      :dialog="dialogConfirm"
      :text="'Are you sure you want to receive this order'"
      :loader="statusLoader"
      @confirm="confirmAction"
      @close="closeConfirm"
    />
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ConfirmDialog from "@/components/front/common/ConfirmDialog";

export default {
  components: { ConfirmDialog },
  computed: {
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
    ...mapGetters(["userRole", "userCategory"]),
  },
  data: () => ({
    searchText: "",
    dialogConfirm: false,
    isloading: false,
    infor_storer_id: null,
    to_date: null,
    from_date: null,
    dateMenu: false,
    dateMenuTo: false,
    summary: false,
    receipt_key: null,
    receipt_no: null,
    orderDetails: [],
    statuses: [],
    status: [],
    headers: [
      {
        text: "Client (Storer)",
        value: "client_name",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 120,
      },
      {
        text: "Warehouse",
        value: "warehouse_name",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "ASN / Receipt (External Key)",
        value: "receipt_key",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "ASN / Receipt Type",
        value: "type",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "ASN / Receipt Status",
        value: "status",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Expected Qty",
        value: "EXPECTED_QTY",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },
      {
        text: "Received Qty",
        value: "RECEIVED_QTY",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },
      {
        text: "Rejected Qty",
        value: "DAMAGE_QTY",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },

      {
        text: "Putaway Qty (Pending)",
        value: "PUTAWAY_COMPLETED_QTY",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },
      {
        text: "Source",
        value: "source",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },

      {
        text: "Created At (By)",
        value: "created_at",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "Updated At (By)",
        value: "updated_at",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        class: "body-1 font-weight-bold",
        width: "120px",
      },
    ],
    inboundOrder: [],
    options: {},
    total: 0,
    warehouse_id: null,
    itemheaders: [
      { text: "SKU", value: "sku", sortable: false },
      {
        text: "External line No",
        value: "externlineno",
        sortable: false,
        width: 200,
      },
      { text: "Line", value: "line", sortable: false },
      { text: "Pack", value: "pack", sortable: false },
      {
        text: "UOM",
        value: "uom",
        sortable: false,
      },
      { text: "Hold Code", value: "hold_code", sortable: false },

      { text: "LPN", value: "lpn", sortable: false },
      { text: "Location", value: "location", sortable: false },
      { text: "Expected Qty", value: "expected_qty", sortable: false },

      // { text: "Received Qty", value: "received_qty", sortable: false },

      { text: "Unit Price", value: "unit_price", sortable: false },
      { text: "Status", value: "status", sortable: false },
    ],
    clients: [],
    selectedClient: null,
    filtersArr: {},
    stores: [],
    warehouses: [],
    tableDetailsItems: [],
    client_variant_sku: [],
    removeItem: {},
    dialog: false,
    transaction_storer_key: [],
    typesArr: [],
    order_type: null,
    selectedItem: {},
    client_receive_enabled: [],
  }),

  watch: {
    options: {
      handler() {
        this.getlist();
      },
      deep: true,
    },
  },
  async created() {
    this.getwarehouse();
    if (this.$store.getters.user.user_category == 3) {
      this.fetchClientList();
    }
    if (this.$store.getters.user.user_category == 1) {
      this.selectedClient = this.$store.getters.user.id;
    }
    this.fetchStatus();
    if (this.$route.query.id) {
      this.receipt_key = this.$route.query.key;
      this.searchAll();
    }
    if (this.$route.query.parent_id) {
      this.receipt_no = this.$route.query.parent_id;
      this.searchAll();
    }
  },

  methods: {
    ...mapActions([
      "snackBar",
      "getInboundOrderBBList",
      "inboundorderSummary",
      "fetchClient",
      "inboundStatus",
      "getChannelDropdown",
      "getWarehouseStores",
      "getInforWarehouseList",
      "inboundSync",
      "inboundCancel",
      "downloadInboundOrderItem",
      "inboundSummarySyncRow",
      "getTypeList",
      "downloadInboundASN",
      "inboundReceive",
    ]),
    onValueChange() {
      this.searchText = ""; // Clear the search input after selection
    },
    checkStatus(item) {
      if (
        item.status == "New" ||
        item.status == "In Transit" ||
        item.status == "Scheduled" ||
        item.status == "In Receiving"
      ) {
        return true;
      }
    },
    edit(item) {
      window.open(
        this.$router.resolve({
          name: "InboundUpload",
          query: {
            key: item.id,
          },
        }).href,
        "_blank"
      );
    },
    closeConfirm() {
      this.dialogConfirm = false;
      this.selectedItem = {};
    },
    openDialog(item) {
      this.selectedItem = item;
      this.dialogConfirm = true;
    },
    confirmAction() {
      this.dialogConfirm = false;
      this.isloading = true;
      let payload = {
        id: this.selectedItem.id,
        request_type: "inbound",
      };
      this.inboundReceive(payload)
        .then((response) => {
          this.snackBar({
            color: "success",
            message: response.data.message,
          });
          this.isloading = false;

          this.fetchList();
        })
        .catch(() => {
          this.isloading = false;
          this.dialogConfirm = false;
        });
    },
    confirmation(item) {
      this.removeItem = item;
      this.dialog = true;
    },
    chechTransaction(item) {
      return this.transaction_storer_key.includes(item.storer_key);
    },

    listPage() {
      this.$router.push({
        name: "inboundBulkorderStatusList",
        params: {
          type: "inbound_upload,inbound_bulk_upload",
        },
      });
    },
    checkIcon(item) {
      return this.client_variant_sku.includes(item.client_id);
    },
    cancelOrder() {
      let payload = {
        id: this.removeItem.id,
      };
      this.inboundCancel(payload).then((response) => {
        this.snackBar({
          color: "success",
          message: response.data.message,
        });
        this.getlist();
      });
    },
    sync() {
      let index = this.warehouses.findIndex(
        (item) => item.id == this.warehouse_id
      );

      let payload = {
        warehouse: this.warehouses[index].name,
      };
      this.inboundSync(payload).then((response) => {
        this.snackBar({
          color: "success",
          message: response.data.message,
        });
        this.getlist();
      });
    },
    syncData(item) {
      this.isloading = true;

      this.syncButton = true;

      let payload = {
        inbound_id: item.id,
      };
      this.inboundSummarySyncRow(payload)
        .then((response) => {
          this.syncButton = false;

          this.snackBar({
            color: "success",
            message: response.data.message,
          });
          this.isloading = false;

          this.getlist();
        })
        .catch(() => {
          this.syncButton = false;
          this.isloading = false;
        });
    },
    downloadData(item) {
      this.downloadInboundOrderItem(item.id)
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },
    downloadASN(item) {
      this.isloading = true;
      this.downloadInboundASN(item.id)
        .then((res) => {
          this.fileDownload(res);
          this.isloading = false;
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    getwarehouse() {
      this.storer_key = "";
      this.sku = null;
      this.warehouse_id = null;

      this.getInforWarehouseList().then((response) => {
        this.warehouses = response.data.result;
      });
    },
    getData(e, type) {
      let searchKey = e.receipt_key;
      if (this.tableDetailsItems.length > 0) {
        let result = this.tableDetailsItems.find(
          (item) => item.RECEIPTKEY === searchKey
        );
        if (result !== undefined && result !== null && result !== "") {
          if (type == "PUTAWAY_COMPLETED_QTY") {
            return (
              this.changeNumberFormat(result.PUTAWAY_COMPLETED_QTY) +
              " (" +
              this.changeNumberFormat(result.PUTAWAY_PENDING_QTY) +
              ")"
            );
          } else if (type == "RECEIVED_QTY") {
            return this.changeNumberFormat(result.TOTAL_QTY_RECEIVED);
          } else if (type == "EXPECTED_QTY") {
            return this.changeNumberFormat(result.EXPECTED_QTY);
          } else if (type == "DAMAGE_QTY") {
            return this.changeNumberFormat(result.DAMAGE_QTY);
          } else {
            return "--";
          }
        } else {
          return "--";
        }
      } else {
        return "--";
      }
    },

    getStores() {
      if (this.selectedClient && this.warehouse_id) {
        let payload = {
          client_id: this.selectedClient,
          warehouse_id: this.warehouse_id,
        };

        this.getWarehouseStores(payload).then((res) => {
          this.stores = res.data;
        });
      } else {
        this.stores = [];
      }
    },
    getType() {
      if (this.warehouse_id) {
        let payload = {
          status_type: "inbound_order_type",
          warehouse_id: this.warehouse_id,
        };
        this.getTypeList(payload).then((res) => {
          this.typesArr = res.data;
        });
      }
      if (this.$store.getters.user.user_category == 1) {
        this.getStores();
      }
    },
    fetchStatus() {
      if (this.statuses.length == 0)
        this.inboundStatus("inbound").then((res) => {
          let statusArr = Object.entries(res.data.data).map(([key, value]) => {
            return { id: key, name: value };
          });
          this.statuses = statusArr;
        });
    },
    clearDateInput(type) {
      if (type == "this.to_date") {
        this.to_date = "";
      } else {
        this.from_date = "";
      }
    },
    allFilters() {
      this.orderLoader = true;
      let obj = {
        client_id: this.selectedClient,
        receipt_key: this.receipt_key
          ? this.receipt_key.trim()
          : this.receipt_key,
        receipt_no: this.receipt_no ? this.receipt_no.trim() : this.receipt_no,
        status: this.status ? this.status.join(",") : "",

        from_date: this.from_date,
        to_date: this.to_date,
        storer_id: this.infor_storer_id,
        warehouse_id: this.warehouse_id,
        order_type: this.order_type,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    clearAll() {
      this.receipt_key = "";
      if (
        this.$store.getters.user.user_category === 6 ||
        this.$store.getters.user.user_category === 3
      ) {
        this.selectedClient = "";
      }
      this.receipt_no = "";
      this.status = "";
      this.from_date = null;
      this.to_date = null;
      this.infor_storer_id = null;
      this.warehouse_id = null;
      this.stores = [];
      this.order_type = null;
      if (this.$store.getters.user.user_category === 6) {
        this.clients = [];
      }
      this.searchAll();
    },

    fetchClientList() {
      this.infor_storer_id = null;

      if (
        this.$store.getters.user.user_category === 3 ||
        this.$store.getters.user.user_category === 6
      ) {
        this.clientLoader = true;
        this.selectedClient = null;
        if (this.$store.getters.user.user_category === 3) {
          var data = {
            fields: "id,name",
            pagination: 0,
            service: "b2b_fulfillment",
            active_facility: 1,
          };
          this.fetchClient(data)
            .then((res) => {
              this.clientLoader = false;
              this.clients = res.data;
            })
            .catch(() => {
              this.clientLoader = false;
            });
        } else if (this.$store.getters.user.user_category === 6) {
          var Ops = {
            fields: "id,name",
            pagination: 0,
            service: "b2b_fulfillment",
            active_facility: 1,
            warehouse_id: this.warehouse_id,
          };
          this.fetchClient(Ops)
            .then((res) => {
              this.clientLoader = false;
              this.clients = res.data;
            })
            .catch(() => {
              this.clientLoader = false;
            });
        }
        this.clientLoader = false;
      }
    },
    getlist() {
      this.getInboundOrderBBList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.inboundOrderLoader = false;
          this.inboundOrder = res.data.records;
          this.tableDetailsItems = res.data.records2;
          this.client_variant_sku = res.data.client_variant_sku;
          this.transaction_storer_key = res.data.transaction_storer_key;
          this.total = res.data.total;
          this.client_receive_enabled = res.data.client_receive_enabled;
        })
        .catch(() => {
          this.inboundOrderLoader = false;
        });
    },

    findSummary(id) {
      window.open(
        this.$router.resolve({
          name: "InboundListView",
          query: {
            id: id,
          },
        }).href,
        "_blank"
      );
    },
    tracking(id) {
      this.orderTracking(id).then((res) => {
        this.trackingDetails = res.data.data.records;
        this.reverseData = res.data.data.event_history;
        this.trackingPage = true;
      });
    },

    async searchAll() {
      this.options.page = 1;
      await this.allFilters();
      this.getInboundOrderBBList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.inboundOrderLoader = false;
          this.inboundOrder = res.data.records;
          this.tableDetailsItems = res.data.records2;
          this.client_variant_sku = res.data.client_variant_sku;
          this.total = res.data.total;
        })
        .catch(() => {
          this.inboundOrderLoader = false;
        });
    },
    gotodetails(item) {
      window.open(
        this.$router.resolve({
          name: "InboundSummary",
          query: {
            key: item.id,
            id: item.client_id,
          },
        }).href,
        "_blank"
      );
    },

    transactionData(item) {
      window.open(
        this.$router.resolve({
          path: "/inbound-transaction",
          query: {
            id: item.id,
          },
        }).href,
        "_blank"
      );
    },
  },
};
</script>
<style scoped>
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 0px 5px 5px !important;
}
.p-0 {
  padding: 0px !important;
}

.custom .v-text-field__details {
  display: none;
}
.loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Ensure the loader appears on top of other content */
}
.loader-wrapper.active {
  display: flex;
}

.content {
  display: none;
}

.loader-wrapper.active + .content {
  display: block;
}
.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite; /* Add a spinning animation */
}
/* Animation keyframes for the loader */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
